import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {ZipFileComponent} from "./zip-file.component";
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule, MultiSelectModule} from "primeng/primeng";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {ProgressBarModule} from 'primeng/progressbar';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    ProgressBarModule,
    CoreModule,
    TableModule,
    TranslateModule,
    MultiSelectModule
    // TaxReportRoutingModule
  ],
  declarations: [ZipFileComponent]
})
export class ZipFileModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file.module.ts